export default __webpack_public_path__ + "static/media/Tureen400.8e282c88.jpg";